import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import ManageReleaseFormFields from '@/components/manage-release-notes/manage-release-form-content/manage-release-form-fields';
import ReleaseFormActions from '@/components/manage-release-notes/manage-release-form-content/release-form-actions';
import ReleaseFormLoading from '@/components/manage-release-notes/manage-release-form-content/release-form-loading';
import VersionWarningModal from '@/components/manage-release-notes/manage-release-form-content/version-warning-modal';
import { Separator } from '@/components/ui/separator';
import useManageReleaseForm from '@/hooks/use-manage-release-form';

const ManageReleaseFormContent = () => {
  const { t } = useTranslation();
  const {
    form,
    id,
    isLoading,
    isError,
    isWarningModalOpen,
    setIsWarningModalOpen,
    onSubmit,
    executeSubmit,
    handleClose,
  } = useManageReleaseForm();

  const { isSubmitting } = form.formState;
  const version = form.watch('version');

  const renderBody = () => {
    if (isLoading || isSubmitting) {
      return <ReleaseFormLoading />;
    }

    if (id && isError) {
      return (
        <div className="h-full flex items-center justify-center text-sm font-medium">
          <p className="text-destructive">{t('errors.release_note.api')}</p>
        </div>
      );
    }

    return <ManageReleaseFormFields />;
  };

  return (
    <>
      <FormProvider {...form}>
        <form
          onSubmit={form.handleSubmit(onSubmit)}
          className="flex flex-col gap-5 max-w-151 pb-8"
          noValidate
        >
          {renderBody()}
          <Separator className="mt-3" />
          <ReleaseFormActions
            id={id}
            isLoading={isLoading}
            isWarningModalOpen={isWarningModalOpen}
            onClose={handleClose}
          />
        </form>
      </FormProvider>

      <VersionWarningModal
        isOpen={isWarningModalOpen && !isLoading}
        onOpenChange={setIsWarningModalOpen}
        version={version}
        onConfirm={executeSubmit}
      />
    </>
  );
};

export default ManageReleaseFormContent;
